import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Card from "@material-ui/core/Card";
import CardActionArea from "@material-ui/core/CardActionArea";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import CardMedia from "@material-ui/core/CardMedia";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import { Link } from "react-router-dom";

const useStyles = makeStyles({
  root: {
    maxWidth: 345,
  },
  media: {
    height: 140,
  },
});

export default function AdminComponent() {
  const classes = useStyles();

  return (
    <div className="container" style={{ marginTop: "100px" }}>
      <div className="row">
        {/* Card One Start */}
        <div className="col-md-4">
          <Card className={classes.root}>
            <CardActionArea>
              <CardMedia
                className={classes.media}
                image="https://images.yourstory.com/cs/1/b3cc3444ab5e11e88691f70342131e20/Whatissoftwareandtypesofsoftwarewithexamples1575272423828jpg"
                title="Contemplative Reptile"
              />
              <CardContent>
                <Typography gutterBottom variant="h5" component="h2">
                  Projects
                </Typography>
                <Typography variant="body2" color="textSecondary" component="p">
                  Manage Projects
                </Typography>
              </CardContent>
            </CardActionArea>
            <CardActions>
              <Link to="/adminproject">
                <Button variant="outlined" color="primary">
                  Manage
                </Button>
              </Link>
            </CardActions>
          </Card>
        </div>

        {/* Card One End */}

        {/* Card Two Start */}
        <div className="col-md-4">
          <Card className={classes.root}>
            <CardActionArea>
              <CardMedia
                className={classes.media}
                image="https://www.quicksilvertranslate.com/wp-content/uploads/education-russia-1.jpg"
                title="Contemplative Reptile"
              />

              <CardContent>
                <Typography gutterBottom variant="h5" component="h2">
                  Education
                </Typography>
                <Typography variant="body2" color="textSecondary" component="p">
                  Manage Education
                </Typography>
              </CardContent>
            </CardActionArea>

            <CardActions>
              <Link to="/admineducation">
                <Button variant="outlined" color="primary">
                  Manage
                </Button>
              </Link>
            </CardActions>
          </Card>
        </div>
        {/* Card Two End */}

        {/* Card Three Start */}
        <div className="col-md-4">
          <Card className={classes.root}>
            <CardActionArea>
              <CardMedia
                className={classes.media}
                image="https://miro.medium.com/max/2552/1*jXI9NY-LrMp8t7fboZ--Rg.jpeg"
                title="Contemplative Reptile"
              />

              <CardContent>
                <Typography gutterBottom variant="h5" component="h2">
                  Experience
                </Typography>
                <Typography variant="body2" color="textSecondary" component="p">
                  Manage Experience
                </Typography>
              </CardContent>
            </CardActionArea>

            <CardActions>
              <Link to="/adminexperience">
                <Button variant="outlined" color="primary">
                  Manage
                </Button>
              </Link>
            </CardActions>
          </Card>
        </div>
        {/* Card Three End */}

        {/* Card Four Start */}
        <div className="col-md-4">
          <Card className={classes.root}>
            <CardActionArea>
              <CardMedia
                className={classes.media}
                image="https://miro.medium.com/max/2552/1*jXI9NY-LrMp8t7fboZ--Rg.jpeg"
                title="Contemplative Reptile"
              />

              <CardContent>
                <Typography gutterBottom variant="h5" component="h2">
                  Blog Post
                </Typography>
                <Typography variant="body2" color="textSecondary" component="p">
                  Manage Blog Post
                </Typography>
              </CardContent>
            </CardActionArea>

            <CardActions>
              <Link to="/adminblog">
                <Button variant="outlined" color="primary">
                  Manage
                </Button>
              </Link>
            </CardActions>
          </Card>
        </div>
        {/* Card Four End */}

        {/* Card Five Start */}
        <div className="col-md-4">
          <Card className={classes.root}>
            <CardActionArea>
              <CardMedia
                className={classes.media}
                image="https://miro.medium.com/max/2552/1*jXI9NY-LrMp8t7fboZ--Rg.jpeg"
                title="Contemplative Reptile"
              />

              <CardContent>
                <Typography gutterBottom variant="h5" component="h2">
                  Certifications
                </Typography>
                <Typography variant="body2" color="textSecondary" component="p">
                  Manage Certifications
                </Typography>
              </CardContent>
            </CardActionArea>

            <CardActions>
              <Link to="/admincertifications">
                <Button variant="outlined" color="primary">
                  Manage
                </Button>
              </Link>
            </CardActions>
          </Card>
        </div>
        {/* Card Five End */}
        {/* Card six Start */}
        <div className="col-md-4">
          <Card className={classes.root}>
            <CardActionArea>
              <CardMedia
                className={classes.media}
                image="https://miro.medium.com/max/2552/1*jXI9NY-LrMp8t7fboZ--Rg.jpeg"
                title="Contemplative Reptile"
              />

              <CardContent>
                <Typography gutterBottom variant="h5" component="h2">
                  Achievements
                </Typography>
                <Typography variant="body2" color="textSecondary" component="p">
                  Manage Achievements
                </Typography>
              </CardContent>
            </CardActionArea>

            <CardActions>
              <Link to="/adminachievements">
                <Button variant="outlined" color="primary">
                  Manage
                </Button>
              </Link>
            </CardActions>
          </Card>
        </div>
        {/* Card six End */}
        {/* Card seven Start */}
        <div className="col-md-4">
          <Card className={classes.root}>
            <CardActionArea>
              <CardMedia
                className={classes.media}
                image="https://miro.medium.com/max/2552/1*jXI9NY-LrMp8t7fboZ--Rg.jpeg"
                title="Contemplative Reptile"
              />

              <CardContent>
                <Typography gutterBottom variant="h5" component="h2">
                  Videos
                </Typography>
                <Typography variant="body2" color="textSecondary" component="p">
                  Manage Videos
                </Typography>
              </CardContent>
            </CardActionArea>

            <CardActions>
              <Link to="/adminvideo">
                <Button variant="outlined" color="primary">
                  Manage
                </Button>
              </Link>
            </CardActions>
          </Card>
        </div>
        {/* Card seven End */}
      </div>
    </div>
  );
}
